import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';

import './edit-survey-item-choice.controller';

const editChoiceViewUrl = require('./edit-survey-item-choice.html');
const editItemViewUrl = require('./edit-item-view.html');
const listChoiceViewUrl = require('./list-choice-view.html');

export class SurveyItemsController {
   isBusy = false;

   language:string;
   languages:string[];

   surveyItems:any[];
   selectedSurveyItem:any;

   static $inject = [
      '$scope', '$uibModal', 'campaignsApi', 'surveyItemsApi', 'dialogs', 'session', 'toast',
      '$compile', '$templateCache', 'titleService', 'loader'
   ];

   constructor (
      private $scope:ng.IScope,
      private $modal:uib.IModalService,
      private campaignsApi,
      private surveyItemsApi,
      private dialogs,
      private session,
      private toast,
      private $compile:ng.ICompileService,
      private $templateCache:ng.ITemplateCacheService,
      titleService,
      private loader)
   {
      titleService.setTitle('Survey Items');
      this.refresh();
   }

   private refresh(clearSelection?:boolean) {
      this.isBusy = true;
      if (clearSelection) {
         this.selectedSurveyItem = null;
      }

      this.campaignsApi.get(this.session.getCampaign().id).then((campaign) => {
         if (!this.language) {
            this.language = campaign.defaultLanguage;
         }
         this.languages = campaign.settings.languages;

         return this.surveyItemsApi.list(this.session.getBrand().id);
      }).then((data) => {
         this.surveyItems = data;
         this.isBusy = false;
      });
   }

   private getSurveyItem() {
      if (this.selectedSurveyItem) {
         this.surveyItemsApi.get(this.selectedSurveyItem.id).then((data) => {
            this.selectedSurveyItem = data;
         });
      }
   }

   addSurveyItem() {
      this.editSurveyItem({BrandId: this.session.getBrand().id});
   }

   editSurveyItem(surveyItem) {
      let modalInstance = this.$modal.open({
         templateUrl: editItemViewUrl,
         controller: 'EditSurveyItemController',
         resolve: {
            language: () => this.language,
            languages: () => this.languages,
            surveyItem: () => surveyItem
         }
      });

      modalInstance.result.then(() => this.refresh());
   }

   removeSurveyItem(surveyItem) {
      this.dialogs.confirm(`Are you sure you want to delete ${surveyItem.key}?`).then(() => {
         this.surveyItemsApi.del(surveyItem.id).then(() => {
            this.refresh(true);
            this.toast.success()
               .message('Survey item deleted!')
               .send();
         }).catch((message) => {
            if (message) {
               this.dialogs.alert(message);
            }
         });
      });
   }

   addSurveyItemChoice() {
      this.editSurveyItemChoice({surveyItemId: this.selectedSurveyItem.id, index: 0});
   }

   editSurveyItemChoice(surveyItemChoice) {
      var modalInstance = this.$modal.open({
         templateUrl: editChoiceViewUrl,
         controller: 'EditSurveyItemChoiceController',
         controllerAs: 'ctrl',
         resolve: {
            language: () => this.language,
            languages: () => this.languages,
            surveyItemChoice: () => surveyItemChoice
         }
      });

      modalInstance.result.then(() => this.getSurveyItem());
   }

   removeSurveyItemChoice(surveyItemChoice) {
      this.dialogs.confirm(`Are you sure you want to delete ${surveyItemChoice.key}?`).then(() => {
         this.surveyItemsApi.removeChoice(surveyItemChoice).then(() => {
            this.getSurveyItem();
            this.toast.success()
               .message('Survey item choice deleted!')
               .send();
         });
      });
   }

   selectSurveyItem(e:MouseEvent, surveyItem) {
      let element = ng.element(e.currentTarget);
      let wrapper = document.getElementById("surveyChoiceWrapper");
      if (wrapper && wrapper.parentNode !== null) {
         wrapper.parentNode.removeChild(wrapper);
      }

      if (this.selectedSurveyItem && surveyItem.id == this.selectedSurveyItem.id) {
         this.selectedSurveyItem = null;
         return;
      }

      this.selectedSurveyItem = surveyItem;
      if (surveyItem.type == 'Boolean' || surveyItem.type == 'Text') {
         return;
      }

      element.find('i.fa-cog').removeClass('hidden');

      this.surveyItemsApi.get(surveyItem.id).then((data) => {
         element.find('i.fa-cog').addClass('hidden');

         this.selectedSurveyItem = data;
         var choices = ng.element(this.$templateCache.get(listChoiceViewUrl));
         this.$compile(choices.contents())(this.$scope);
         choices.insertAfter(element);
      });
   }

   export() {
      this.loader.showSpinner();
      this.surveyItemsApi.export(this.session.getBrand().id)
         .then(() => this.loader.hide());
   }

   import($file:File) {
      // for some reason, second time using import causes this to file with null file
      if (!$file) return;

      this.loader.showSpinner();
      this.surveyItemsApi.import(this.session.getBrand().id, $file)
         .then((response) => {
            if (response.status) {
               this.loader.hide();
               this.refresh();
            } else {
               let message = `${response.message}. Are you sure?`;
               return this.dialogs.confirm(message).then(() => {
                  return this.surveyItemsApi.import(this.session.getBrand().id, $file, true)
                     .then(() => this.refresh())
                     .finally(() => this.loader.hide());
               }).catch(() => {
                  this.loader.hide();
               });
            }
         });
   }
}

ng.module('e360')
   .controller('SurveyItemsController', SurveyItemsController);
